import { Component, createRef } from 'react';
import { connect } from 'react-redux';
var eruda = require('eruda');

class Debugger extends Component {

    constructor(props) {
        super(props);
        this.container = createRef();

        this.state = {
            debugging: props.context.debugging,
        }
    }

    componentDidMount() {
        eruda.init({
            container: this.container.current
        });

        eruda.get().config.set('displaySize', 40)
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.context.debugging !== prevState.debugging) {
            if (nextProps.context.debugging)
                eruda.show();
            else
                eruda.hide();

            return { debugging: nextProps.context.debugging }
        }

        return prevState;
    }

    render() {
        return (<div ref={this.container} className={this.props.context.debugging ? "" : "hidden"}></div>)
    }
}

const mapStateToProps = (state) => {
    return {
        context: state.context
    };
};

const mapDispatchToProps = () => {
    return {

    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Debugger);
